import { render, staticRenderFns } from "./Oratori.vue?vue&type=template&id=7840057a&scoped=true&"
import script from "./Oratori.vue?vue&type=script&lang=js&"
export * from "./Oratori.vue?vue&type=script&lang=js&"
import style0 from "./Oratori.vue?vue&type=style&index=0&id=7840057a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840057a",
  null
  
)

export default component.exports